"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiFormHelperTextOverrides = void 0;
var createMuiFormHelperTextOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        root: {
            marginTop: spacing(1),
            "&$disabled": {
                color: undefined,
                opacity: palette.action.disabledOpacity,
            },
        },
        contained: {
            marginLeft: undefined,
            marginRight: undefined,
        },
    });
};
exports.createMuiFormHelperTextOverrides = createMuiFormHelperTextOverrides;
//# sourceMappingURL=MuiFormHelperText.js.map